import { GetPromptList } from '@/api/fe-api/view/queries/ai/get-prompt-list';

export type AiChatboxDescriptionProps = {
  onSubmitPrompt: (prompt: string) => void;
};

export function AiChatboxDescription({
  onSubmitPrompt,
}: AiChatboxDescriptionProps) {
  const { data } = GetPromptList.useQuery();

  return (
    <div className="space-y-4">
      <h2 className="text-center text-lg font-semibold text-neutral-800">
        What can I help with?
      </h2>
      <div className="mx-auto grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
        {data?.prompts.questions.map((prompt, index) => (
          <button
            key={index}
            className="w-full justify-start rounded-lg border border-neutral-200 p-4 text-xs text-neutral-600 transition-colors duration-200 hover:bg-neutral-50"
            onClick={() => onSubmitPrompt(prompt)}
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
}
